import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Honor from './views/Honor.vue'
import News from './views/News.vue'
import Announcement from './views/Announcement.vue'
import Product from './views/Product.vue'
import Social from './views/Social.vue'
import Partner from './views/Partner.vue'
import Recruitment from './views/Recruitment.vue'
import Contact from './views/Contact.vue'
import NewsItem from './views/NewsItem.vue'
import ProductItem from './views/ProductItem.vue'
import RecruitmentItem from './views/RecruitmentItem.vue'
import SocialItem from './views/SocialItem.vue'

Vue.use(Router)


export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/home',
        },
        {
            path: '/home',
            name: 'Home',
            component: Home,
        },
        {
            path: '/about',
            name: 'About',
            component: About,
        },
        {
            path: '/honor',
            name: 'Honor',
            component: Honor
        },
        {
            path: '/news',
            name: 'News',
            component: News
        },
        {
            path: '/announcement',
            name: 'Announcement',
            component: Announcement
        },
        {
            path: '/product',
            name: 'Product',
            component: Product
        },
        {
            path: '/social',
            name: 'Social',
            component: Social
        },
        {
            path: '/social/:id',
            name: 'SocialItem',
            component: SocialItem
        },
        {
            path: '/partner',
            name: 'Partner',
            component: Partner
        },
        {
            path: '/recruitment',
            name: 'Recruitment',
            component: Recruitment
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/news/:id',
            name: 'NewsItem',
            component: NewsItem
        },
        {
            path: '/product/:type',
            name: 'ProductItem',
            component: ProductItem
        },
        {
            path: '/recruitment/:id',
            name: 'RecruitmentItem',
            component: RecruitmentItem
        }
    ]
})